import React, { useEffect, useState } from "react";
import toast, { Toaster } from "react-hot-toast";
import "./Miscellaneous.css";
import { EventEmitter } from "../../utility/events";
import AppWebSocketComp from "../AppWebSocketComp";
let _ = require("lodash");

const Miscellaneous = (props) => {
  console.log("Miscellaneous Loaded")
  const [chatClientFirst, setChatClientFirst] = useState(null);
  const [chatClientSecond, setChatClientSecond] = useState(null);

  useEffect(() => {
    console.log("Miscellaneous Loaded useEffect")
    // subscribe("PAYMENT_REQUEST", () => sendCannedMessage("PAYMENT_REQUEST"));
    EventEmitter.subscribe("CHAT_CLIENT_FIRST", (val) => {
      setChatClientFirst(val);
    });

    EventEmitter.subscribe("CHAT_CLIENT_SECOND", (val) => {
      setChatClientSecond(val);
    });

    EventEmitter.subscribe("CHECK_ATTACHMENTS_no", (val) => {
      console.log("CHECK_ATTACHMENTS EVENT", val);
    });
    return () => {
      EventEmitter.unsubscribe("CHECK_ATTACHMENTS_no");
    };
  }, []);
  const getChatTranscript = async (chatSession) => {
    const transcriptResponse = await chatSession.getTranscript({
      maxResults: 100,
      scanDirection: "BACKWARD",
      sortOrder: "ASCENDING",
      startPosition: {},
    });
    const { InitialContactId, NextToken, Transcript } = transcriptResponse.data;
    let attachmentList = _.filter(transcriptResponse.data, {
      Type: "ATTACHMENT",
    });
    console.log("attachmentList", attachmentList);
  };

  const chechAttachment = () => {
    let activeChatId = sessionStorage.getItem("activeChat");
    if (
      chatClientFirst &&
      chatClientFirst.contactId &&
      chatClientFirst.contactId === activeChatId
    ) {
      getChatTranscript(chatClientFirst);
    } else if (
      chatClientSecond &&
      chatClientSecond.contactId &&
      chatClientSecond.contactId === activeChatId
    ) {
      getChatTranscript(chatClientFirst);
    } else {
      toast.error("Please select a chat to send message.");
    }
  };

  const sentVideoLink = (id) => {
    EventEmitter.dispatch("SEND_MESSAGE", {
      'type' : "video",
      'videoId' : id
    });
  };

  return (
    <div className="container-fluid custom-container-wrapper p-0">
        <ul className="list-group">
          <li className="list-group-item active content-header-bg" aria-current="true">Youtube Video Links</li>
          <li className="list-group-item d-flex justify-content-between align-items-center">
            Sears Home Warranty
            <button type="button" className="btn btn-primary" onClick={()=>sentVideoLink('s18qF19m2PM')}>Sent</button>
          </li>
          <li className="list-group-item d-flex justify-content-between align-items-center">
            Sears Home Warranty 1
            <button type="button" className="btn btn-primary" onClick={()=>sentVideoLink('VhuXaAVftxc')}>Sent</button>
          </li>
          <li className="list-group-item d-flex justify-content-between align-items-center">
            Sears Home Service HI
            <button type="button" className="btn btn-primary" onClick={()=>sentVideoLink('KZsyQMSjJGE')}>Sent</button>
          </li>
        </ul>
        </div>
  );
};

export default Miscellaneous;
